import Lenis, { LenisOptions } from "lenis";
import { easeInOutSine } from "../../shared/utils/easeInOutSine";

interface SmoothScrollOptions {
  offset?: number;
  duration?: number;
  immediate?: boolean;
}

export class SmoothScroller {
  private lenis: Lenis | null = null;
  init(options: LenisOptions) {
    this.lenis = new Lenis({
      autoRaf: true,
      ...options,
    });

    return this.lenis;
  }

  rebind(options: LenisOptions) {
    if (this.lenis) {
      this.lenis.destroy();
    }

    return this.init(options);
  }

  setInstance(instance: Lenis | null) {
    this.lenis = instance;
  }

  scrollTo(
    target: HTMLElement,
    {
      offset = 0,
      duration = 0.85,
      immediate = false,
    }: SmoothScrollOptions = {},
  ) {
    if (this.lenis) {
      this.lenis.scrollTo(target, {
        offset,
        duration,
        immediate,
        easing: easeInOutSine,
        lock: true,
      });
    } else {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  scrollToTop(options: SmoothScrollOptions = {}) {
    if (this.lenis) {
      this.lenis.scrollTo(0, options);
    } else {
      window.scrollTo(0, 0);
    }
  }
}

export const smoothScroller = new SmoothScroller();
